import { useContext } from 'react'
import { ThemeContext } from './contexts/theme'
import { LanguageProvider } from './contexts/language'
import Header from './components/Header/Header'
import About from './components/About/About'
import Projects from './components/Projects/Projects'
import Experience from './components/Experience/Experience'
import Skills from './components/Skills/Skills'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import './App.css'

const App = () => {
  const [{ themeName }] = useContext(ThemeContext)

  return (
    <div id='top' className={`${themeName} app`}>
      <LanguageProvider>
        <Header />

        <main>
          <About />
          <Projects />
          <Experience />
          <Skills />
          <Contact />
        </main>

        <ScrollToTop />
        <Footer />
      </LanguageProvider>
    </div>
  )
}

export default App
